export const chatActions = {
  setConversations,
  addConversation,
  updateConversation,
  setActiveChat,
  addMessage,
  markMessagesAsRead,
  setUnreadCount,
  setSocketConnected,
  setTyping,
};

export const chatConstants = {
  SET_CONVERSATIONS: "chat/set-conversations",
  ADD_CONVERSATION: "chat/add-conversation",
  UPDATE_CONVERSATION: "chat/update-conversation",
  SET_ACTIVE_CHAT: "chat/set-active-chat",
  ADD_MESSAGE: "chat/add-message",
  MARK_MESSAGES_AS_READ: "chat/mark-messages-as-read",
  SET_UNREAD_COUNT: "chat/set-unread-count",
  SET_SOCKET_CONNECTED: "chat/set-socket-connected",
  SET_TYPING: "chat/set-typing",
};

function setConversations(conversations) {
  return {
    type: chatConstants.SET_CONVERSATIONS,
    conversations,
  };
}

function addConversation(conversation) {
  return {
    type: chatConstants.ADD_CONVERSATION,
    conversation,
  };
}

function updateConversation(chatId, conversation) {
  return {
    type: chatConstants.UPDATE_CONVERSATION,
    chatId,
    conversation,
  };
}

function setActiveChat(chatId) {
  return {
    type: chatConstants.SET_ACTIVE_CHAT,
    chatId,
  };
}

function addMessage(chatId, message) {
  return {
    type: chatConstants.ADD_MESSAGE,
    chatId,
    message,
  };
}

function markMessagesAsRead(chatId) {
  return {
    type: chatConstants.MARK_MESSAGES_AS_READ,
    chatId,
  };
}

function setUnreadCount(count) {
  return {
    type: chatConstants.SET_UNREAD_COUNT,
    count,
  };
}

function setSocketConnected(connected) {
  return {
    type: chatConstants.SET_SOCKET_CONNECTED,
    connected,
  };
}

function setTyping(chatId, userId, isTyping) {
  return {
    type: chatConstants.SET_TYPING,
    chatId,
    userId,
    isTyping,
  };
}

